/**
 * Mock post-call analysis data (Smiles spec shape).
 * In production, this would come from API (e.g. campaign calls with analysis).
 */
import type { AnalysisRecord } from '../config/types';

export const MOCK_ANALYSIS_CALLS: AnalysisRecord[] = [
  {
    id: 1,
    call_outcome: 'InstalledConfirmed',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'PostDownloadHelp',
    interest_category: 'Dining',
    interest_level: 'Positive',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 4,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 2,
    call_outcome: 'InstalledConfirmed',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Closing',
    interest_category: 'Shopping',
    interest_level: 'Positive',
    device_type: 'Android',
    store_path: 'GooglePlay',
    install_step_reached: 4,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 3,
    call_outcome: 'InstalledConfirmed',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Verification',
    interest_category: 'Both',
    interest_level: 'Positive',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 4,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'Arabic',
  },
  {
    id: 4,
    call_outcome: 'InstalledConfirmed',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Closing',
    interest_category: 'Dining',
    interest_level: 'Positive',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 4,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 5,
    call_outcome: 'InstalledConfirmed',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'PostDownloadHelp',
    interest_category: 'Shopping',
    interest_level: 'Neutral',
    device_type: 'Android',
    store_path: 'GooglePlay',
    install_step_reached: 4,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 6,
    call_outcome: 'InstalledConfirmed',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Verification',
    interest_category: 'Dining',
    interest_level: 'Positive',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 4,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 7,
    call_outcome: 'InstalledConfirmed',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Closing',
    interest_category: 'Both',
    interest_level: 'Positive',
    device_type: 'Android',
    store_path: 'GooglePlay',
    install_step_reached: 4,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'Arabic',
  },
  {
    id: 8,
    call_outcome: 'InstalledConfirmed',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'PostDownloadHelp',
    interest_category: 'Dining',
    interest_level: 'Positive',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 4,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Partial',
    language: 'English',
  },
  {
    id: 9,
    call_outcome: 'InstalledConfirmed',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Closing',
    interest_category: 'Shopping',
    interest_level: 'Hesitant',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 4,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 10,
    call_outcome: 'Started',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Install',
    interest_category: 'Dining',
    interest_level: 'Positive',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 2,
    install_blocker: 'CantFindApp',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 11,
    call_outcome: 'Started',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'DeviceSelection',
    interest_category: 'Shopping',
    interest_level: 'Hesitant',
    device_type: 'Android',
    store_path: 'GooglePlay',
    install_step_reached: 1,
    install_blocker: 'Confusion',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 12,
    call_outcome: 'Started',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Install',
    interest_category: 'Both',
    interest_level: 'Positive',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 3,
    install_blocker: 'Connectivity',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'Arabic',
  },
  {
    id: 13,
    call_outcome: 'Started',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Verification',
    interest_category: 'Dining',
    interest_level: 'Neutral',
    device_type: 'Android',
    store_path: 'GooglePlay',
    install_step_reached: 2,
    install_blocker: 'Confusion',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Partial',
    language: 'English',
  },
  {
    id: 14,
    call_outcome: 'Started',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Install',
    interest_category: 'Shopping',
    interest_level: 'Hesitant',
    device_type: 'Huawei',
    store_path: 'AppGallery',
    install_step_reached: 1,
    install_blocker: 'StoreUnavailable',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 15,
    call_outcome: 'Declined',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'DownloadOffer',
    interest_category: 'Unsure',
    interest_level: 'Neutral',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'NotInterested',
    refusal_handling_result: 'ReasonCaptured',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 16,
    call_outcome: 'Declined',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'InterestDiscovery',
    interest_category: 'Unsure',
    interest_level: 'Negative',
    device_type: 'Android',
    store_path: 'Unknown',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoTime',
    refusal_handling_result: 'ReasonCaptured',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 17,
    call_outcome: 'Declined',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'DownloadOffer',
    interest_category: 'Other',
    interest_level: 'Negative',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'TrustIssue',
    refusal_handling_result: 'ReasonCaptured',
    validation_status: 'Valid',
    language: 'Arabic',
  },
  {
    id: 18,
    call_outcome: 'Declined',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'DeviceSelection',
    interest_category: 'Shopping',
    interest_level: 'Hesitant',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 0,
    install_blocker: 'RefusedMidway',
    primary_objection: 'WantsLink',
    refusal_handling_result: 'ReasonCaptured',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 19,
    call_outcome: 'Declined',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'ValueExplanation',
    interest_category: 'Unsure',
    interest_level: 'Negative',
    device_type: 'Android',
    store_path: 'GooglePlay',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'PrefersWebsite',
    refusal_handling_result: 'ReasonCaptured',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 20,
    call_outcome: 'Declined',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'DownloadOffer',
    interest_category: 'Other',
    interest_level: 'Negative',
    device_type: 'IPhone',
    store_path: 'Unknown',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'Other',
    refusal_handling_result: 'NotCaptured',
    validation_status: 'Partial',
    language: 'English',
  },
  {
    id: 21,
    call_outcome: 'HardStop',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Opening',
    interest_category: 'Unsure',
    interest_level: 'Negative',
    device_type: 'Unknown',
    store_path: 'Unknown',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'StopCalling',
    refusal_handling_result: 'ReasonCaptured',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 22,
    call_outcome: 'HardStop',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'IntroCheck',
    interest_category: 'Unsure',
    interest_level: 'Negative',
    device_type: 'IPhone',
    store_path: 'Unknown',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'StopCalling',
    refusal_handling_result: 'ReasonCaptured',
    validation_status: 'Valid',
    language: 'Arabic',
  },
  {
    id: 23,
    call_outcome: 'HardStop',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Opening',
    interest_category: 'Unsure',
    interest_level: 'Negative',
    device_type: 'Android',
    store_path: 'Unknown',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'StopCalling',
    refusal_handling_result: 'ReasonCaptured',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 24,
    call_outcome: 'ImmediateHangup',
    track_type: 'Acquisition',
    app_status: 'Unknown',
    last_state: 'Opening',
    interest_category: 'Unsure',
    interest_level: 'Negative',
    device_type: 'Unknown',
    store_path: 'Unknown',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: null,
  },
  {
    id: 25,
    call_outcome: 'ImmediateHangup',
    track_type: 'Acquisition',
    app_status: 'Unknown',
    last_state: 'Opening',
    interest_category: 'Unsure',
    interest_level: 'Negative',
    device_type: 'Unknown',
    store_path: 'Unknown',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: null,
  },
  {
    id: 26,
    call_outcome: 'ImmediateHangup',
    track_type: 'Acquisition',
    app_status: 'Unknown',
    last_state: 'Opening',
    interest_category: 'Unsure',
    interest_level: 'Negative',
    device_type: 'IPhone',
    store_path: 'Unknown',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'Language',
    refusal_handling_result: 'NotCaptured',
    validation_status: 'Partial',
    language: 'Other',
  },
  {
    id: 27,
    call_outcome: 'TechnicalFail',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Install',
    interest_category: 'Dining',
    interest_level: 'Positive',
    device_type: 'Android',
    store_path: 'GooglePlay',
    install_step_reached: 2,
    install_blocker: 'Connectivity',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 28,
    call_outcome: 'TechnicalFail',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'DeviceSelection',
    interest_category: 'Shopping',
    interest_level: 'Neutral',
    device_type: 'Huawei',
    store_path: 'AppGallery',
    install_step_reached: 1,
    install_blocker: 'StoreUnavailable',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'Arabic',
  },
  {
    id: 29,
    call_outcome: 'Dropped',
    track_type: 'Acquisition',
    app_status: 'NotInstalled',
    last_state: 'Install',
    interest_category: 'Dining',
    interest_level: 'Positive',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 1,
    install_blocker: 'Other',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Partial',
    language: 'English',
  },
  {
    id: 30,
    call_outcome: 'Dropped',
    track_type: 'Unknown',
    app_status: 'Unknown',
    last_state: 'ValueExplanation',
    interest_category: 'Unsure',
    interest_level: 'Neutral',
    device_type: 'Android',
    store_path: 'Unknown',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Partial',
    language: 'English',
  },
  {
    id: 31,
    call_outcome: 'ExistingUserFeedbackCaptured',
    track_type: 'ExistingUser',
    app_status: 'AlreadyInstalled',
    last_state: 'Closing',
    interest_category: 'Dining',
    interest_level: 'Positive',
    device_type: 'IPhone',
    store_path: 'AppStore',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Valid',
    language: 'English',
  },
  {
    id: 32,
    call_outcome: 'ExistingUserFeedbackCaptured',
    track_type: 'ExistingUser',
    app_status: 'AlreadyInstalled',
    last_state: 'ResolutionCheck',
    interest_category: 'Shopping',
    interest_level: 'Hesitant',
    device_type: 'Android',
    store_path: 'GooglePlay',
    install_step_reached: 0,
    install_blocker: 'NoBlocker',
    primary_objection: 'NoObjection',
    refusal_handling_result: 'NotApplicable',
    validation_status: 'Partial',
    language: 'Arabic',
  },
];
